import { Badge, Button, Dropdown, Form, message, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useMemo, useState } from 'react'
import { checkValidFormFieldValue } from '../../utils/helper'
import { Tuning2OutlineIcon } from '../../components/AppIcon'

const { Option } = Select

const UserAccountManagementPageAdvanceFilterV2 = props => {
  const [showFilter, setShowFilter] = useState(false)

  const {
    userStore,
    departmentStore,
    loadingAnimationStore,
    authenticationStore,
  } = props

  const {
    userListStatus,
    userListDepartmentCode,
    userListSortDirection,
    userListSortBy,
  } = userStore

  const { departmentList } = departmentStore

  useEffect(() => {
    loadingAnimationStore.showSpinner(true)
    ;(async () => {
      if (authenticationStore.currentCompanyCode()) {
        try {
          departmentStore.getDepartmentListFromCompanyCode(
            authenticationStore.currentCompanyCode()
          )
        } catch (error) {
          console.log(error)
          message.error(error?.vi || 'Đã có lỗi xảy ra!')
        } finally {
          loadingAnimationStore.showSpinner(false)
        }
      }
    })()
  }, [authenticationStore.currentUser])

  const [form] = Form.useForm()
  const values = Form.useWatch([], form)
  const { setFieldsValue } = form

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(userListStatus)) count++
    if (hasValue(userListDepartmentCode)) count++
    if (hasValue(userListSortDirection)) count++
    if (hasValue(userListSortBy)) count++

    return count
  }, [
    userListStatus,
    userListDepartmentCode,
    userListSortDirection,
    userListSortBy,
  ])

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        status:
          typeof userListStatus === 'boolean' ? userListStatus : undefined,
        department: userListDepartmentCode || undefined,
        direction: userListSortDirection || undefined,
        sort_by: userListSortBy || undefined,
      })
    }
  }, [
    userListStatus,
    userListDepartmentCode,
    userListSortDirection,
    userListSortBy,
    setFieldsValue,
    showFilter,
  ])

  const onFinish = values => {
    userStore.setAccountManagementPageAdvanceFilterV2Values(values)
    onToggleFilter()
  }

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item label={'Sắp xếp theo'} name="sort_by">
                <Select
                  className="h-40"
                  allowClear
                  //   onChange={handleSortByType}
                  placeholder={'Sắp xếp theo'}
                  showArrow>
                  <Option value={'nameUppercase'}>Họ tên</Option>
                  <Option value={'username'}>Tên đăng nhập</Option>
                </Select>
              </Form.Item>
              <Form.Item label={'Thứ tự'} name="direction">
                <Select
                  className="h-40"
                  allowClear
                  //   onChange={handleSortByDirection}
                  placeholder={'Lựa chọn'}
                  showArrow>
                  <Option value={'ASC'}>Tăng dần</Option>
                  <Option value={'DESC'}>Giảm dần</Option>
                </Select>
              </Form.Item>

              <Form.Item label={'Trạng thái'} name="status">
                <Select
                  className="h-40"
                  allowClear
                  //   onChange={handleFilterByStatus}
                  placeholder={'Trạng thái'}
                  showArrow>
                  <Option value={true}>Active</Option>
                  <Option value={false}>Inactive</Option>
                </Select>
              </Form.Item>

              <Form.Item label={'Phòng ban'} name="department">
                <Select
                  className="h-40"
                  allowClear
                  showSearch
                  //   onChange={handleFilterByDepartment}
                  placeholder={'Phòng ban'}
                  filterOption={true}
                  optionFilterProp={'name'}>
                  {departmentList.map(department => {
                    return (
                      <Option
                        key={department.code}
                        name={department.name}
                        value={department.code}>
                        {department.name}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  if (userStore.clearUserListFilter) {
                    userStore.clearUserListFilter()
                  }
                  onToggleFilter()
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

export default inject(
  'userStore',
  'departmentStore',
  'loadingAnimationStore',
  'authenticationStore'
)(observer(UserAccountManagementPageAdvanceFilterV2))
